// extracted by mini-css-extract-plugin
export var footerNewsletter = "inscriptionNewsletter-module--footer-newsletter--7e50c";
export var footerNewsletterInput = "inscriptionNewsletter-module--footer-newsletter-input--1aa0c";
export var sectionAlert = "inscriptionNewsletter-module--section-alert--a2044";
export var sectionAlertButton = "inscriptionNewsletter-module--section-alert-button--4f68a";
export var sectionAlertContent = "inscriptionNewsletter-module--section-alert-content--6112b";
export var sectionAlertHeader = "inscriptionNewsletter-module--section-alert-header--7f059";
export var sectionAlertModal = "inscriptionNewsletter-module--section-alert-modal--6c173";
export var sectionAlertTitle = "inscriptionNewsletter-module--section-alert-title--5b0de";